import React from "react";
import styles from "../styles/hero.module.css";

function Hero() {
    return (
        <section className={styles.hero}>
            <div className={styles.heroContent}>
                <h1>21st Bournemouth 
                    <span>
                        <span> Squirrels</span>
                        <span> Beavers</span>
                        <span> Cubs</span>
                        <span> Scouts</span>
                        <span> Squirrels</span>
                    </span>
                </h1>
            </div>
        </section>
    );
}


export default Hero;
